import { format as formatDateFn } from "date-fns";
import _, { isDate } from "lodash";

import { isEmptyValue } from "utils/isEmptyValue";
import { generateRandomId } from "utils/utils";
export type TDate = Date | null | string;
export function mapDatesToSelectOptions(
  dates: TDate[],
  format = "yyyy-MM-dd",
  shouldFormat = false,
) {
  const correctDates = _.filter(dates, (date) => !isEmptyValue(date));
  return _.compact(
    _.map(correctDates, (date) => {
      if (!date) {
        return undefined;
      }
      const dateValue =
        shouldFormat && isDate(date) ? formatDateFn(date, format) : date;
      return {
        key: generateRandomId(),
        label: dateValue,
        value: dateValue,
      };
    }),
  );
}
